import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { NavLink, useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import "../../constants/css/custom_styles.css";
import { HiHome } from "react-icons/hi";
import { AiOutlineAppstore } from "react-icons/ai";
import { PiInvoice, PiPackageBold } from "react-icons/pi";
import { GiMedicinePills } from "react-icons/gi";
import { GrHelpBook } from "react-icons/gr";
import { MdDewPoint } from "react-icons/md";
import { FaFileExcel } from "react-icons/fa";

const AccountSidebar = () => {
  const location = useLocation();
  let isTab = useMediaQuery({ query: "(max-width: 768px)" });
  const [isOpen, setIsOpen] = useState(isTab ? false : true);

  const [isActive, setIsActive] = useState({
    excel: false,
    home: false,
    doctor: false,
  });

  useEffect(() => {
    setIsOpen(!isTab);
  }, [isTab]);

  useEffect(() => {
    const path = location.pathname;

    setIsActive({
      excel: path.includes("/account/download-excel"),
      home: path.includes("/account/home"),
      package: path.includes("/account/package"),
      consultancy: path.includes("/account/consultancy"),
      medicine: path.includes("/account/medicine"),
      issuedMedicine: path.includes("/account/issued-medicine"),
      hudInvoices: path.includes("/account/hud/invoices"),
    });
  }, [location.pathname]);

  const handleIsActive = (key) => {
    setIsActive((prevState) => ({
      ...prevState,
      [key]: !prevState[key],
    }));
  };

  return (
    <motion.div
      initial={{ x: -250 }}
      animate={{ x: isOpen ? 0 : -250 }}
      className="bg-secondary text-[#ffffff] shadow-xl w-[16rem] max-w-[16rem] h-full md:overflow-y-scroll 2xl:overflow-hidden md:relative  fixed pl-2"
    >
      <div className="flex flex-col justify-between h-full">
        <div
          className={`text-md whitespace-pre pb-2 pt-4 flex flex-row gap-2 font-bold ${isOpen ? "block" : "hidden"}`}
        >
          <HiHome size={23} />
          Account View
        </div>
        <hr className="border-white my-2" />
        <div className="overflow-y-auto flex-1">
          {/* Menus */}
          <div className="flex flex-col h-full">
            {/* First */}
            <ul className="whitespace-pre px-2.5 text-[0.9rem] py-3 flex flex-col gap-2 font-medium scrollbar-thin h-full md:h-full">
              {<li>
                <NavLink
                  to="/account/home"
                  className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.home ? "text-white bg-primary rounded-md" : ""
                    }`}
                  onClick={() => handleIsActive("home")}
                >
                  <AiOutlineAppstore size={23} />
                  <p className={`whitespace-pre ${isOpen ? "block" : "hidden"}`}>
                    Home
                  </p>
                </NavLink>
              </li>}
              {<li>
                <NavLink
                  to="/account/download-excel"
                  className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.excel ? "text-white bg-primary rounded-md" : ""
                    }`}
                  onClick={() => handleIsActive("download-excel")}
                >
                  <FaFileExcel size={23} />
                  <p className={`whitespace-pre ${isOpen ? "block" : "hidden"}`}>
                    Excel Download
                  </p>
                </NavLink>
              </li>}
              {<li>
                <NavLink
                  to="/account/package"
                  className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.package ? "text-white bg-primary rounded-md" : ""
                    }`}
                  onClick={() => handleIsActive("package")}
                >
                  <PiPackageBold size={23} />
                  <p className={`whitespace-pre ${isOpen ? "block" : "hidden"}`}>
                    Package Invoice
                  </p>
                </NavLink>
              </li>}
              {<li>
                <NavLink
                  to="/account/consultancy"
                  className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.consultancy ? "text-white bg-primary rounded-md" : ""
                    }`}
                  onClick={() => handleIsActive("consultancy")}
                >
                  <GrHelpBook size={23} />
                  <p className={`whitespace-pre ${isOpen ? "block" : "hidden"}`}>
                    Consultancy Invoice
                  </p>
                </NavLink>
              </li>}
              {<li>
                <NavLink
                  to="/account/medicine"
                  className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.medicine ? "text-white bg-primary rounded-md" : ""
                    }`}
                  onClick={() => handleIsActive("medicine")}
                >
                  <GiMedicinePills size={23} />
                  <p className={`whitespace-pre ${isOpen ? "block" : "hidden"}`}>
                    Medicines Invoice
                  </p>
                </NavLink>
              </li>}
              {<li>
                <NavLink
                  to="/account/issued-medicine"
                  className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.issuedMedicine ? "text-white bg-primary rounded-md" : ""
                    }`}
                  onClick={() => handleIsActive("issuedMedicine")}
                >
                  <MdDewPoint size={23} />
                  <p className={`whitespace-pre ${isOpen ? "block" : "hidden"}`}>
                    Issued Medicines Invoice
                  </p>
                </NavLink>
              </li>}
              {<li>
                <NavLink
                  to="/account/hud/invoices"
                  className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.hudInvoices ? "text-white bg-primary rounded-md" : ""
                    }`}
                  onClick={() => handleIsActive("hudInvoices")}
                >
                  <PiInvoice size={23} />
                  <p className={`whitespace-pre ${isOpen ? "block" : "hidden"}`}>
                    HUD Invoice
                  </p>
                </NavLink>
              </li>}
            </ul>
          </div>

        </div>
        <p className="text-[0.8rem] mb-4">
          © Developed By: Rashail Tech. Labs
        </p>
      </div>
    </motion.div>
  );
};

export default AccountSidebar;
